<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getList,
  add,
  del,
  addFee,
  update,
  getDetails,
  recalculate,
  sync,
  createBill,
  pushToTMS,
} from "@/api/finance/dduShipment";
import cTable from "@/base/common/index";
import { getCountry } from "@/api/system/country";
import { getPayType } from "@/api/public";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import { getAgent } from "@/api/tracker/agent";
import { getExpense } from "@/api/finance/expense";
export default {
  name: "other_fee",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        getDetails,
        del,
        add,
        update,
        list: getList,
        recalculate,
        sync,
        createBill,
        addFee,
        getExpense,
        pushToTMS,
        beforeHandleList: ({ data }) => {
          console.log(data);
          if (!this.init) {
            this.init = true;
            let key = "other_fee_list";
            let other_fee_list = data.rows[0].other_fee_list;
            this.fields.splice(16, 0, {
              name: () => this.$t("cost_t"),
              key: "cost",
              children: [
                {
                  name: () => this.$t("Bayan charges"),
                  key: "bayan_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("Bank charges"),
                  key: "bank_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("Legalization"),
                  key: "legalization_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("Nas handling"),
                  key: "nas_handle_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("Global charges"),
                  key: "global_fee",
                  minWidth: 100,
                },

                {
                  name: () => this.$t("Insurance"),
                  key: "insurance_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("Custom duty"),
                  key: "duty_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("bill_proceeds_issuing_charge"),
                  key: "handling_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("Administration fee"),
                  key: "administration_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("VATFee"),
                  key: "vat_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("document_fee"),
                  key: "paper_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("clearanceFee"),
                  key: "clearance_fee",
                  minWidth: 100,
                },
                ...Object.keys(other_fee_list).map((t) => {
                  return {
                    name: other_fee_list[t].name,
                    key: "other_fee_list." + t + ".amount",
                    minWidth: 100,
                  };
                }),
                {
                  name: () => this.$t("totalFee"),
                  key: "total_fee",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("currencyCode"),
                  key: "origin_currency",
                  minWidth: 100,
                },
              ],
            });
          }
          this.$nextTick(() => {
            this.$refs["table"].getTable().refreshColumn();
            this.$forceUpdate();
          });
          this.$forceUpdate();
          console.log(data.rows[0]);
          return data.rows;
        },
      },
      footer: {},
      config: {
        height: 630,
        contentMethod({ row, column }) {
          if (column.type == "calculate_status" && row.calculate_msg) {
            return row.calculate_msg;
          }
        },
      },
      modals: {
        freightAppend: {
          // contentSlot: "freight",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(
                  "addFee",
                  {
                    data: JSON.parse(JSON.stringify(this.list)),
                    ids: this.$page.selectAll.map((t) => t.id),
                  },
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => true,
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning",
                    },
                    icon: "md-add",
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    disabled({ row }) {
                      return this.list.length == 1 || row.allow_del == 0;
                    },
                  },
                ],
                methods: {
                  add() {
                    this.getModal("freightAppend").list.unshift({
                      expense_item_id: "",
                      expense_item_name: "",
                      amount: 0,
                    });
                  },
                  delete({ rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.getModal("freightAppend").list.splice(rowIndex, 1);
                      },
                    });
                  },
                },
              },
              {
                name: () => this.$t("expense"),
                align: "left",
                key: "expense_item_id",
                placeholder() {
                  return this.$t("select") + this.$t("expense");
                },
                component: "Select",
                bind: {
                  style: "width:100%",
                  type: "number",
                },
                config: {
                  label({ row }) {
                    return row.name + (row.pin ? "(" + row.pin + ")" : "");
                  },
                  value: "id",
                },
                methods: {
                  async list({ field }) {
                    field.options = (await getExpense()).data.payload.rows;
                    this.$forceUpdate();
                  },
                },
              },
              {
                name: () => this.$t("reChAmount"),
                align: "left",
                key: "amount",
                component: "InputNumber",
                bind: {
                  min: 0,
                  style: "width:100%",
                },
              },
            ],
          },
        },
        createBill: {
          type: "add",
          methods: {
            ok: ({ row, close }) => {
              let data = JSON.parse(JSON.stringify(row));
              let table = this.$refs["table"];
              data.ids = table.selectAll.map((item) => item.id);
              table
                .handleRequestMethods("createBill", data, true, true)
                .then((res) => {
                  table.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 30,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bill_name: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur",
                },
              ],
              bill_type: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ bill_name: 24 }, { bill_type: 24 }, { bill_remarks: 24 }],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "bill_name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: this.$t("whether") + this.$t("show") + "SKU",
              key: "show_sku",
              component: "Radio",
              placeholder: () =>
                this.$t("select") +
                this.$t("whether") +
                this.$t("show") +
                "SKU",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 },
              ],
              default: 0,
              bind: {
                border: true,
              },
            },
            {
              name: this.$t("SettlementObject"),
              key: "bill_type",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("SettlementObject"),
              options: [
                { label: this.$t("agentT"), value: 1 },
                { label: this.$t("Customer"), value: 2 },
                { label: this.$t("branchOffice"), value: 3 },
              ],
              default: 1,
              bind: {
                border: true,
              },
            },
            {
              name: this.$t("Remarks"),
              key: "bill_remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur",
                },
              ],
              code: [
                {
                  required: true,
                  message: "code cannot be empty",
                  trigger: "blur",
                },
              ],
              affect_field: [
                {
                  required: true,
                  message: "affect_field cannot be empty",
                  trigger: "blur",
                },
              ],
              enable: [
                {
                  required: true,
                  type: "number",
                  message: "enable cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { title: 24 },
            { code: 24 },
            { def_value: 24 },
            { affect_field: 24 },
            { sort: 24 },
            { enable: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("zhTitle"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("zhTitle");
              },
            },
            {
              name: () => this.$t("contraband_code"),
              key: "code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("code");
              },
            },
            {
              name: () => this.$t("def") + this.$t("number"),
              key: "def_value",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("def") + this.$t("number");
              },
            },
            {
              name: () =>
                this.$t("mapping1") + this.$t("Billing") + this.$t("field"),
              key: "affect_field",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("mapping1") +
                  this.$t("Billing") +
                  this.$t("field")
                );
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 3,
                type: "textarea",
              },
            },
            {
              name: () => this.$t("exlType"),
              key: "enable",
              component: "Radio",
              options: [
                { label: this.$t("enable"), value: 1 },
                { label: this.$t("disable"), value: 2 },
              ],
              bind: {
                border: true,
              },
              default: 1,
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              },
              bind: {
                step: 1,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [
              { label: this.$t("calculationTime"), value: 1 },
              { label: this.$t("outboundTime"), value: 2 },
              { label: this.$t("inboundTime"), value: 3 },
            ],
            default: 1,
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "finance_obj",
            placeholder() {
              return this.$t("select") + this.$t("SettlementObject");
            },
            component: "Select",
            options: [
              { label: this.$t("agentT"), value: 1 },
              { label: this.$t("Customer"), value: 2 },
              { label: this.$t("branchOffice"), value: 3 },
            ],
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "pay_type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("orderservice");
            },
            clearable: true,
            options: [],
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "calculate_status",
            component: "Select",
            placeholder() {
              return this.$t("expType");
            },
            clearable: true,
            options: [
              { label: this.$t("billFailed"), value: 0 },
              {
                label: this.$t("billSuccess"),
                value: 1,
              },
            ],
            bind: {
              style: "width:100px",
            },
          },
          {
            key: "finance_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("cod_status");
            },
            clearable: true,
            options: [
              { label: this.$t("noOrder"), value: 0 },
              { label: this.$t("isOrder"), value: 1 },
              { label: this.$t("objection"), value: 3 },
              { label: this.$t("Settled"), value: 9 },
            ],
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_depart");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "deliver",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            component: "Select",
            options: [],
            config: {
              label: "agent_name",
              value: "id",
            },
          },

          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("add"),
            //   type: "add",
            //   fnName: "add",
            //   bind: {
            //     icon: "md-add",
            //     type: "warning",
            //   },
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("synchronous"),
              type: "synchronous",
              fnName: "synchronousFn",
              bind: {
                icon: "md-refresh",
                type: "success",
              },
            },
            {
              name: () => this.$t("resAmount"),
              type: "resAmount",
              fnName: "resAmount",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
              // id: 389,
            },
            {
              name: () => this.$t("createBill"),
              type: "createBill",
              fnName: "createBill",
              bind: {
                icon: "md-add",
                type: "warning",
              },
            },
            {
              name: () => this.$t("setting") + this.$t("freight_append"),
              type: "append",
              fnName: "append",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.selectAll.reduce((a, b) => {
                    if (!a) a = b.to_country;
                    if (a !== b.to_country) return -1;
                    return a;
                  }, "") === -1
                );
              },
            },
            {
              name: () => this.$t("pushTMS"),
              type: "pushToTMS",
              fnName: "pushToTMS",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
              // id: 389,
            },
          ],
          methods: {
            pushToTMS() {
              let data = this.selectAll.map((item) => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("pushTMS"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "pushToTMS",
                    {
                      ids: data,
                    },
                    true,
                    true
                  );
                },
              });
            },
            append() {
              this.getModal("freightAppend").open({}, function () {
                this.setTitle(this.$t("setting") + this.$t("freight_append"));
                this.list.push({
                  expense_item_id: "",
                  expense_item_name: "",
                  amount: 0,
                });
              });
            },
            createBill({ searchForm }) {
              this.getModal("append").open();
            },
            createBill({ searchForm }) {
              this.getModal("createBill").open(searchForm);
            },
            export() {
              console.log("chufa");
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
            resAmount() {
              let data = this.selectAll.map((item) => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("resAmount"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "recalculate",
                    {
                      ids: data,
                    },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            synchronousFn() {
              this.$Modal.confirm({
                title: this.$t("synchronous"),
                width: 300,
                content:
                  this.$t("whether") +
                  this.$t("confirmOrder") +
                  this.$t("synchronous") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("sync", null, true).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("Odd_Numbers"),
          key: "airway_bill_number",
          minWidth: 130,
          fixed: "left",
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("agentT"),
          key: "deliver",
          minWidth: 130,
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          minWidth: 130,
        },
        {
          name: () => this.$t("b2bClient"),
          key: "client_account",
          minWidth: 130,
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman_account",
          minWidth: 130,
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("shipperRef"),
          key: "client_refer_code",
          minWidth: 130,
        },
        {
          name: () => this.$t("orderservice"),
          key: "pay_type",
          minWidth: 130,
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          minWidth: 130,
        },
        {
          name: () => this.$t("country_t"),
          children: [
            {
              name: () => this.$t("allow_depart"),
              key: "from_country",
              minWidth: 100,
            },
            {
              name: () => this.$t("allow_arrive"),
              key: "to_country",
              minWidth: 100,
            },
            {
              name: () => this.$t("city_t"),
              key: "city_name",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("trajectory"),
          children: [
            {
              name: () => this.$t("tracker_code"),
              key: "trace_status",
              minWidth: 100,
            },
            {
              name: () => this.$t("track_title"),
              key: "trace_remarks",
              minWidth: 100,
            },
            {
              name: () => this.$t("tracker_time"),
              key: "trace_time",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          minWidth: 100,
        },
        {
          name: () => this.$t("USD To Destination Currency Rate"),
          key: "usd_to_rate",
          minWidth: 100,
        },
        {
          name: () => this.$t("invoiceWeight"),
          children: [
            {
              name: () => this.$t("actual_weight"),
              key: "check_weight",
              minWidth: 100,
            },
            {
              name: () => this.$t("charge_volume"),
              key: "charge_volume",
              minWidth: 100,
            },
            {
              name: () => this.$t("charge_params"),
              key: "charge_weight",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("SettlementFee"),
          children: [
            {
              name: () => this.$t("Bayan charges"),
              key: "to_fee_list.bayan_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("Bank charges"),
              key: "to_fee_list.bank_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("Legalization"),
              key: "to_fee_list.legalization_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("Nas handling"),
              key: "to_fee_list.nas_handle_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("Global charges"),
              key: "to_fee_list.global_fee",
              minWidth: 100,
            },

            {
              name: () => this.$t("Insurance"),
              key: "to_fee_list.insurance_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("Custom duty"),
              key: "to_fee_list.duty_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("VATFee"),
              key: "to_fee_list.vat_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("document_fee"),
              key: "to_fee_list.paper_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("clearanceFee"),
              key: "to_fee_list.clearance_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("totalFee"),
              key: "to_fee_list.total_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("currencyCode"),
              key: "to_fee_list.origin_currency",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("bindFreight"),
          key: "quotation_name",
          align: "left",
          width: 130,
          component: "a",
          methods: {
            click({ row }) {
              this.$page.toPage("freight", row.quotation_name);
            },
          },
        },
        {
          name: () => this.$t("SettlementAgent"),
          children: [
            {
              name: () => this.$t("bill_number"),
              key: "agent_bill_number",
              minWidth: 100,
              component: "a",
              methods: {
                click({ row }) {
                  this.$page.toPage("dduBill", row.agent_bill_number);
                },
              },
            },
            {
              name: () => this.$t("SettlementStatus"),
              key: "agent_status_txt",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("SettlementCustomers"),
          children: [
            {
              name: () => this.$t("bill_number"),
              key: "client_bill_number",
              minWidth: 100,
              methods: {
                click({ row }) {
                  this.$page.toPage("dduBill", row.client_bill_number);
                },
              },
            },
            {
              name: () => this.$t("SettlementStatus"),
              key: "client_status_txt",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("exlType"),
          key: "calculate_status_txt",
          type: "calculate_status",
          minWidth: 80,
          noDeep: true,
          fixed: "right",
          bind: {
            style({ row }) {
              return {
                color: row.calculate_status == 1 ? "#4caf50" : "#f44336",
              };
            },
          },
          methods: {
            render: ({ row }) => {
              return row.calculate_status == 1
                ? this.$t("billSuccess")
                : this.$t("billFailed");
            },
          },
        },
        /* {
					type: "btns",
					width: 150,
					name: () => this.$t("operation"),
					fixed: "right",
					list: [
						{
							name: () => this.$t("update"),
							type: "update",
							fnName: "update",
							bind: {
								type: "success",
							},
						},
						{
							name: this.$t("delete"),
							type: "delete",
							fnName: "delete",
						},
					],

					methods: {
						update({ row }) {
							this.handleRequestMethods("getDetails", row.id).then((res) => {
								this.getModal("add").setTitle(this.$t("update"));
								this.getModal("add").type = "update";
								this.getModal("add").open(res.payload);
							});
						},
						delete({ row }) {
							this.$Modal.confirm({
								title: this.$t("delete"),
								width: 300,
								content: this.$t("titleModal"),
								onOk: () => {
									this.handleRequestMethods("del", row.id).then((res) => {
										this.$Message["success"]({
											background: true,
											content: res.msg,
										});
										this.getList()
									});
								},
							});
						},
					},
				}, */
      ],
    };
  },
  async mounted() {
    let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
    let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    let client = (await getAllClient()).data.payload.rows;
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    let companiesList = (await getCompanies()).data.payload;
    let agent = (await getAgent()).data.payload.rows;
    let pay_type = (await getPayType()).data.payload;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
      if (item.key === "client_id") item.options = client;
      if (item.key === "salesman_id") item.options = salesman;
      if (item.key === "ownership") item.options = companiesList;
      if (item.key === "deliver") item.options = agent;
      if (item.key === "pay_type")
        item.options = Object.values(pay_type).map((t) => ({
          value: t,
          label: t,
        }));
    });
  },
};
</script>
